export default "__VITE_ASSET__6d6596f5__"